import { Responsive } from 'connex-cds';
import UnloadingPointDesktop from './UnloadingPointDesktop';
import { useTicketContext } from '../../../TicketContext';
import React, { useCallback, useMemo } from 'react';
import { filter, find, get } from 'lodash';
import UnloadingPointMobile from './UnloadingPointMobile';

export const UnloadingPoint = () => {
  const { ticket, isStandAloneTicket } = useTicketContext();

  const deliveryAddress = useMemo(() => {
    const address = ticket?.destination?.address;
    const stateZip = [address?.countrySubDivision, address?.postalCode].filter(Boolean).join(' ');
    return [address?.address1, address?.address2, address?.city, stateZip].filter(Boolean).join(', ');
  }, [ticket?.destination?.address]);

  const siteContact = useMemo(() => {
    if (!ticket?.destination?.contacts?.length) {
      return { phone: '', name: '' };
    }

    const contactFallback = { phone: '', name: '', firstName: '', lastName: '' };
    const [otherContact] = filter(ticket?.destination?.contacts, contact => Boolean(contact?.phone)) ?? [];
    if (otherContact) {
      const { phone, name, firstName, lastName } = otherContact;
      const fullName = name ?? `${firstName ?? ''}${firstName && lastName ? ' ' : ''}${lastName ?? ''}`;
      contactFallback.phone = phone;
      contactFallback.name = fullName;
    }

    const contact = find(ticket?.destination?.contacts, { contactRole: 'general' });
    if (contact && contact?.phone) {
      const { phone, name, firstName, lastName } = contact;
      const fullName = name ?? `${firstName ?? ''}${firstName && lastName ? ' ' : ''}${lastName ?? ''}`;
      return { phone, name: fullName ?? contactFallback?.name };
    }

    return { phone: contactFallback?.phone ?? '', name: contactFallback?.name ?? '' };
  }, [ticket?.destination?.contacts]);

  const getDatetime = useCallback(
    (key, oldKey) => {
      const event = get(ticket, `scheduledEvents.${key}`);
      if (event?.eventDateTime) {
        return event.eventDateTime;
      }
      if (typeof event === 'string') {
        return event;
      }
      return get(ticket, `customData.schedule.${oldKey}`, null);
    },
    [ticket]
  );

  const datetimeUnloading = getDatetime('UNLOADING', 'deliveryTimeFrom');
  const datetimeArriveJob = getDatetime('ARRIVE_JOB', 'agreeWindowFrom');
  const datetimeEndUnloading = getDatetime('END_UNLOADING', 'agreeWindowTo');

  return (
    <Responsive>
      <UnloadingPointMobile
        deliveryAddress={deliveryAddress}
        siteContact={siteContact}
        ticket={ticket}
        unloading={datetimeUnloading}
        arriveJob={datetimeArriveJob}
        endUnloading={datetimeEndUnloading}
        isStandAloneTicket={isStandAloneTicket}
      />
      <UnloadingPointDesktop
        deliveryAddress={deliveryAddress}
        siteContact={siteContact}
        ticket={ticket}
        unloading={datetimeUnloading}
        arriveJob={datetimeArriveJob}
        endUnloading={datetimeEndUnloading}
        isStandAloneTicket={isStandAloneTicket}
      />
    </Responsive>
  );
};
